export type KPIOverviewView = "cards" | "compact" | "table";

export const DEFAULT_KPI_OVERVIEW_VIEW: KPIOverviewView = "cards";

export const KPI_OVERVIEW_VIEWS: { value: KPIOverviewView; label: string }[] = [
  { value: "cards", label: "Cards" },
  { value: "compact", label: "Compact" },
  { value: "table", label: "Table" },
];

export const parseKPIOverviewView = (value: string | null): KPIOverviewView =>
  KPI_OVERVIEW_VIEWS.find((view) => view.value === value)?.value ??
  DEFAULT_KPI_OVERVIEW_VIEW;
